import { IFormViewForm } from 'components/FormView';

const ReceiptConfirmationForm: IFormViewForm = {
    id: 'ReceiptConfirmationForm',
    layout: {
        rows: 1,
        columns: 1
    },
    fields: [
        {
            id: '1',
            position: {
                row: 1,
                col: 1,
                colspan: 3
            },
            type: 'PAPER_CONTAINER',
            props: {
                elevation: 0
            },
            children: [
                {
                    id: 0,
                    type: 'TOGGLE_FIELD',
                    visible: true,
                    style: {
                        display: 'inline-block',
                        width: '35%',
                    },
                    props: {
                        name: 'OutputUnpacking',
                        label: 'Unpacking report'
                    }
                },
                {
                    id: 1,
                    type: 'DOCUMENT_OUTPUT_FIELD',
                    visible: true,
                    style: {
                        display: 'inline-block',
                        width: '65%',
                    },
                    props: {
                        size: 'large',
                        label: 'Print to printer',
                        name: 'UnpackingOutput',
                        fieldId: 'UnpackingOutput',
                        documentType: 'PR',
                        precedentFields: ['OutputUnpacking'],
                        isCustomerSupplierScoped: true,
                    }
                },
                {
                    id: 2,
                    type: 'TOGGLE_FIELD',
                    visible: true,
                    style: {
                        display: 'inline-block',
                        width: '35%',
                    },
                    props: {
                        name: 'OutputShelf',
                        label: 'Shelf label'
                    }
                },
                {
                    id: 3,
                    type: 'DOCUMENT_OUTPUT_FIELD',
                    visible: true,
                    style: {
                        display: 'inline-block',
                        width: '65%',
                    },
                    props: {
                        size: 'large',
                        label: 'Print to printer',
                        name: 'ShelfOutput',
                        fieldId: 'ShelfOutput',
                        documentType: 'PR',
                        precedentFields: ['OutputShelf'],
                        isCustomerSupplierScoped: true,
                    }
                },
                {
                    id: 4,
                    type: 'TOGGLE_FIELD',
                    visible: true,
                    style: {
                        display: 'inline-block',
                        width: '35%',
                    },
                    props: {
                        name: 'OutputStock',
                        label: 'Stock label',
                        defaultValue: true
                    }
                },
                {
                    id: 5,
                    type: 'DOCUMENT_OUTPUT_FIELD',
                    visible: true,
                    style: {
                        display: 'inline-block',
                        width: '65%',
                    },
                    props: {
                        size: 'large',
                        label: 'Print to printer',
                        name: 'StockOutput',
                        fieldId: 'StockOutput',
                        documentType: 'PR',
                        precedentFields: ['OutputStock'],
                        isCustomerSupplierScoped: true,
                    }
                },
                {
                    id: 6,
                    type: 'DIVIDER',
                    props: {
                    }
                },
                {
                    id: 7,
                    type: 'TEXT_FIELD',
                    props: {
                        label: 'Reference',
                        name: 'Reference',
                        placeholder: '',
                        size: 'medium',
                        required: false
                    }
                },
                {
                    id: 8,
                    type: 'EX_LOOKUP_FIELD',
                    props: {
                        label: 'User ID',
                        name: 'UserId',
                        size: 'small',
                        lookupName: 'Personnel',
                        isLookupTypeFixed: true,
                        required: true,
                    }
                },
                {
                    id: 9,
                    type: 'TEXT_FIELD',
                    props: {
                        label: 'PIN',
                        name: 'Pin',
                        placeholder: '****',
                        size: 'small',
                        type: 'password',
                        inputProps: {
                            maxLength: 4
                        },
                        required: false
                    }
                }
            ]
        }
    ]
};
export default ReceiptConfirmationForm;
